export default {
  methods: {
    sendQuestionGtm(type, id, price = this.prices.czk) {
      this.sendEcommerceGtm(type, id, price, 'CZK', [{ item_id: 'Q_001', item_name: 'Question' }]);
    },

    sendEcommerceGtm(payment_type, transaction_id, value, currency, items) {
      this.gtmPush({
        event: 'purchase',
        'payment.type': payment_type,
        transaction_id,
        value,
        currency,
        items
      });
    }
  }
};
